// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const absol_mega: PokeData = {
  "id": 10057,
  "name": "absol-mega",
  "height": 12,
  "weight": 490,
  "base_experience": 198,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "scratch",
    "razor-wind",
    "swords-dance",
    "leer",
    "bite",
    "quick-attack",
    "double-team",
    "slash",
    "perish-song",
    "detect",
    "pursuit",
    "future-sight",
    "taunt",
    "feint",
    "me-first",
    "sucker-punch",
    "night-slash",
    "psycho-cut"
  ],
  "moves": [
    "scratch",
    "leer",
    "bite",
    "quick-attack",
    "pursuit",
    "future-sight",
    "night-slash",
    "crunch",
    "dark-pulse",
    "snatch",
    "dark-bargain",
    "snarl",
    "night-daze"
  ],
  "evolution_chain": {
    "id": 185,
    "item": null,
    "species": [
      {
        "name": "absol",
        "order": 389,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 76,
    "speed": 140,
    "ability_power": 183
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
